import dayjs from 'dayjs'

import { useLineChart } from '@/pages/ui/line-chart/use-line-chart'

import type { ResGetCaseProcessingTimeTrendItem } from '@/lib/queries/case/public/trend/processing-time/types'

export const ProcessingTimeTrendChartTooltip: React.FC = () => {
  const { activeIndex, data } = useLineChart()

  if (activeIndex === null) {
    return null
  }

  const activeData = data[activeIndex] as ResGetCaseProcessingTimeTrendItem | null

  if (!activeData) {
    return null
  }

  return (
    <div>
      <div className="mb-[5px] text-xs text-muted-foreground">{dayjs(activeData.date).format('MMM YYYY')}</div>
      <div className="mb-[5px] text-xs font-medium text-[hsla(0,0%,33%,1)]">80% of cases are completed within</div>
      <div className="my-[5px] h-[1px] w-full bg-[hsla(0,0%,93%,1)]" />
      <div className="text-[20px] font-semibold tracking-[-0.1px]">
        {Number(activeData.estimatedTime?.toFixed(2)) ?? '-'} Month
        {activeData.estimatedTime === 1 ? '' : 's'}
      </div>
    </div>
  )
}
